module.exports = __webpack_public_path__ + "img/5.1a40fb35.png";